"use client";

import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { getSiteContent } from "@/content/site";
import { useLocale } from "@/lib/i18n/provider";

export default function ScrollToTop() {
  const { locale } = useLocale();
  const {
    common: { backToTopLabel },
  } = getSiteContent(locale);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          onClick={scrollUp}
          aria-label={backToTopLabel}
          className="fixed bottom-6 right-6 z-50 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-[var(--color-surface-border-strong)] bg-[var(--color-bg-raised)] text-[var(--color-text-primary)] shadow-[var(--shadow-soft)] transition-all duration-200 hover:scale-110 hover:border-[var(--color-accent-base)] hover:bg-[var(--color-surface-glass)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-accent-base)] sm:h-11 sm:w-11"
        >
          <ArrowUp size={18} className="text-current" aria-hidden="true" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
